import { Package, Radar, User as UserIcon } from "lucide-react";
import { useAuth } from "@/lib/AuthContext";
import Avatar from "@/components/Avatar";

// Menú inferior de navegación estático para el landing en móvil.
// Cotizar abre el cotizador del landing en modal, Rastreo abre el rastreador
// en modal y Cuenta abre el modal de cuenta/usuario con avatar.
export default function LandingBottomNav({ onOpenQuote, onOpenTracker, onOpenAccount }) {
  const { user } = useAuth();
  const item = "flex-1 flex flex-col items-center gap-1 py-2 text-[0.6rem] font-medium uppercase tracking-wide text-ink-muted hover:text-cyan transition-colors";
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 flex border-t border-ink-border bg-ink-surface safe-bottom">
      <button onClick={onOpenQuote} className={`touch-icon ${item}`} aria-label="Cotizar envío">
        <Package className="w-5 h-5" /> Cotizar
      </button>
      <button onClick={onOpenTracker} className={`touch-icon ${item}`} aria-label="Rastreo de envíos">
        <Radar className="w-5 h-5" /> Rastreo
      </button>
      <button onClick={onOpenAccount} className={`touch-icon ${item}`} aria-label="Mi cuenta">
        {user ? <Avatar user={user} size={20} /> : <UserIcon className="w-5 h-5" />} Cuenta
      </button>
    </nav>
  );
}